import { getAuthAxiosBackend } from "../../helpers/axios"

class MartyrServices{

    get(id){
        return getAuthAxiosBackend().get('health-card/martyrs/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('health-card/martyrs', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('health-card/martyrs/' + id)
    }
}

export default new MartyrServices()